export const GET_ALL_EVENTS_STARTED = 'GET_ALL_EVENTS_STARTED';
export const GET_ALL_EVENTS_SUCCESS = 'GET_ALL_EVENTS_SUCCESS';
export const GET_ALL_EVENTS_FAILURE = 'GET_ALL_EVENTS_FAILURE';
